import { Pressable, View } from "react-native";
import { colors } from "../../theme";
import { Text } from "react-native-paper";

const PersistentSnackbar = ({
  IconComp,
  text,
  action,
  borderColor = "border-blue-light",
  backgroundColor = colors.blue.lightest,
}: {
  IconComp: React.ComponentType<{ color: string; size: number }>;
  text: string;
  action: () => void;
  borderColor?: string;
  backgroundColor?: string;
}) => {
  return (
    <Pressable onPress={action}>
      <View testID="persistent-snackbar" className={`mt-4 border p-3 rounded-lg ${borderColor}`} style={{ backgroundColor }}>
        <View className="flex-row items-center justify-between">
          <View className="flex-row items-center">
            <IconComp color={colors.blue.DEFAULT} size={24} />
            <Text className="text-small-tight text-ink-darkest ml-4">{text}</Text>
          </View>
          <Text className="text-small-tight text-primary">View</Text>
        </View>
      </View>
    </Pressable>
  );
};

export default PersistentSnackbar;
